import React from 'react';

function MmaLogin() {
  const mmaUrl = process.env.REACT_APP_MMA_LOGIN;

  const handleClick = () => {
    window.location.href = mmaUrl;
  };

  return (
    <a
      className="top-menu"
      style={{ cursor: 'pointer' }}
      onClick={handleClick}
    >
      MMA Login
    </a>
  );
}

export default MmaLogin;